import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { get as getNotifications } from 'features/notifications/store/actions'
import { getUser } from 'features/session/store/actions'
import { getTeamList, getArchiveTeamList } from 'features/teamlist/store/actions'
import { getTodoList, getArchiveList } from 'features/todolist/store/actions'
import { getAndUpdateTask, removeTask } from 'features/task/store/actions'
import { getLastSortKey } from 'features/todolist/store/selectors'
import mqtt from 'mqtt'
import { iot } from 'gipsy-api'
import logger from 'utils/logger'
import { utils } from 'gipsy-misc'

const CLIENT_DISCONNECTED = 'client-disconnected'

const TASK_MYSCHEDULE_BASE_TOPIC = 'task/my-schedule/'
const TASK_WATCHED_BASE_TOPIC = 'task/watched/'
const TASK_UPDATE_BASE_TOPIC = 'task/update/'
const TASK_DELETE_BASE_TOPIC = 'task/archive/delete/'
const TASK_MYARCHIVE_BASE_TOPIC = 'task/archive/my-tasks/'
const TASK_WATCHED_ARCHIVE_BASE_TOPIC = 'task/archive/watched/'
const EVENT_BASE_TOPIC = 'event/'
const NOTIF_BASE_TOPIC = 'notif/'
const USER_BASE_TOPIC = 'user/'

const getConnectionPayload = (id, displayName) => {
  try {
    return JSON.stringify({ clientId: id, username: displayName })
  } catch (err) {
    logger.error(err)
    return null
  }
}

const validateClientConnected = client => {
  if (!client) {
    throw new Error('Client is not connected yet. Call client.connect() first!')
  }
}

const mapStateToProps = state => ({
  session: state.session,
  activeTeamMember: state.teamlist.activeTeamMember,
  todoArchiveLastSortKey: getLastSortKey(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getTodoList,
      getArchiveList,
      getTeamList,
      getArchiveTeamList,
      getNotifications,
      getAndUpdateTask,
      getUser,
      removeTask
    },
    dispatch
  )
})

class RealTime extends Component {
  componentDidMount() {
    const { session } = this.props
    if (session.id) {
      this.connect(session.id, session.user.displayName)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { session } = nextProps
    if (nextProps.session.id && this.props.session.id !== nextProps.session.id) {
      this.connect(session.id, session.user.displayName)
    }
  }

  connect = async (id, displayName) => {
    if (this.isConnected) {
      return
    }

    const options = {
      will: {
        topic: CLIENT_DISCONNECTED,
        payload: getConnectionPayload(id, displayName)
      }
    }

    let wssUrl
    try {
      wssUrl = await iot.get()
    } catch (err) {
      this.isConnected = false
      logger.error(err)
      return
    }

    this.client = mqtt.connect(wssUrl, options)
    this.client.on('connect', this.onConnect)
    this.client.on('close', this.onClose)
    this.client.on('message', this.onMessage)
  }

  onConnect = () => {
    this.isConnected = true
    const { session } = this.props
    const TASK_MYSCHEDULE_TOPIC = `${TASK_MYSCHEDULE_BASE_TOPIC}${session.id}`
    this.client.subscribe(TASK_MYSCHEDULE_TOPIC)
    const TASK_WATCHED_TOPIC = `${TASK_WATCHED_BASE_TOPIC}${session.id}`
    this.client.subscribe(TASK_WATCHED_TOPIC)
    const TASK_UPDATE_TOPIC = `${TASK_UPDATE_BASE_TOPIC}${session.id}`
    this.client.subscribe(TASK_UPDATE_TOPIC)
    const TASK_DELETE_TOPIC = `${TASK_DELETE_BASE_TOPIC}${session.id}`
    this.client.subscribe(TASK_DELETE_TOPIC)
    const TASK_MYARCHIVE_TOPIC = `${TASK_MYARCHIVE_BASE_TOPIC}${session.id}`
    this.client.subscribe(TASK_MYARCHIVE_TOPIC)
    const TASK_WATCHED_ARCHIVE_TOPIC = `${TASK_WATCHED_ARCHIVE_BASE_TOPIC}${session.id}`
    this.client.subscribe(TASK_WATCHED_ARCHIVE_TOPIC)
    const EVENT_TOPIC = `${EVENT_BASE_TOPIC}${session.id}`
    this.client.subscribe(EVENT_TOPIC)
    const NOTIF_TOPIC = `${NOTIF_BASE_TOPIC}${session.id}`
    this.client.subscribe(NOTIF_TOPIC)
    const USER_TOPIC = `${USER_BASE_TOPIC}${session.id}`
    this.client.subscribe(USER_TOPIC)
  }

  onClose = () => {
    validateClientConnected(this.client)
    this.client.end()
    this.isConnected = false
  }

  onMessage = (topic, message) => {
    const { session } = this.props
    validateClientConnected(this.client)
    const TASK_MYSCHEDULE_TOPIC = `${TASK_MYSCHEDULE_BASE_TOPIC}${session.id}`
    const TASK_WATCHED_TOPIC = `${TASK_WATCHED_BASE_TOPIC}${session.id}`
    const TASK_UPDATE_TOPIC = `${TASK_UPDATE_BASE_TOPIC}${session.id}`
    const TASK_DELETE_TOPIC = `${TASK_DELETE_BASE_TOPIC}${session.id}`
    const TASK_MYARCHIVE_TOPIC = `${TASK_MYARCHIVE_BASE_TOPIC}${session.id}`
    const TASK_WATCHED_ARCHIVE_TOPIC = `${TASK_WATCHED_ARCHIVE_BASE_TOPIC}${session.id}`
    const EVENT_TOPIC = `${EVENT_BASE_TOPIC}${session.id}`
    const NOTIF_TOPIC = `${NOTIF_BASE_TOPIC}${session.id}`
    const USER_TOPIC = `${USER_BASE_TOPIC}${session.id}`

    let payload
    switch (topic) {
      case TASK_MYSCHEDULE_TOPIC:
      case EVENT_TOPIC:
        this.props.actions.getTodoList()
        break
      case TASK_WATCHED_TOPIC:
        payload = JSON.parse(message)
        if (utils.user.areSameUser(this.props.activeTeamMember, payload.assignee)) {
          this.props.actions.getTeamList(payload.assignee)
        }
        break
      case NOTIF_TOPIC:
        this.props.actions.getNotifications()
        break
      case TASK_UPDATE_TOPIC:
        payload = JSON.parse(message)
        this.props.actions.getAndUpdateTask(payload.taskId)
        break
      case TASK_DELETE_TOPIC:
        payload = JSON.parse(message)
        this.props.actions.removeTask(payload.taskId)
        break
      case TASK_MYARCHIVE_TOPIC:
        if (this.props.todoArchiveLastSortKey) {
          this.props.actions.getArchiveList(this.props.todoArchiveLastSortKey, 0, 'greaterThanEqual')
        }

        break
      case TASK_WATCHED_ARCHIVE_TOPIC:
        payload = JSON.parse(message)
        if (utils.user.areSameUser(this.props.activeTeamMember, payload.assignee)) {
          this.props.actions.getArchiveTeamList(this.props.activeTeamMember)
        }
        break
      case USER_TOPIC:
        this.props.actions.getUser()
        break
      default:
        break
    }
  }

  render() {
    return this.props.children
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  {
    pure: true
  }
)(RealTime)



// WEBPACK FOOTER //
// ./src/features/realTime/index.js